const PATHS = {
  tree: 'M12 21v-6m0 0-4-3m4 3 4-3M8 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm8 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm-4-3V3m-6 18h12',
  dna: 'M7 3c0 4 10 5 10 9s-10 5-10 9M17 3c0 4-10 5-10 9s10 5 10 9M8.5 6h7m-7 12h7M10 9.5h4m-4 5h4',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm5-2 5 5',
  globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3 12h18M12 3c2.5 2.5 3.8 5.5 3.8 9s-1.3 6.5-3.8 9c-2.5-2.5-3.8-5.5-3.8-9S9.5 5.5 12 3Z',
  'phone-app': 'M7 2h10a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm4 17h2',
  card: 'M3 6h18v12H3zM3 10h18M7 15h4',
  heart: 'M12 20s-7.5-4.5-7.5-10A4.5 4.5 0 0 1 12 7.3 4.5 4.5 0 0 1 19.5 10C19.5 15.5 12 20 12 20Z',
  bell: 'M6 16V11a6 6 0 1 1 12 0v5l1.5 2h-15L6 16Zm4 4h4',
  download: 'M12 3v12m0 0-4.5-4.5M12 15l4.5-4.5M4 17v3h16v-3',
  mic: 'M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3Zm-6.5 9a6.5 6.5 0 0 0 13 0M12 18.5V21m-3.5 0h7',
  wave: 'M3 12h2m3-5v10m4-13v16m4-11v6m4-3h1',
  bolt: 'M13 2 4 14h7l-1 8 9-12h-7l1-8Z',
  command: 'M9 6v12M15 6v12M6 9h12M6 15h12M9 6a3 3 0 1 0-3 3m12 0a3 3 0 1 0-3-3M6 15a3 3 0 1 0 3 3m6 0a3 3 0 1 0 3-3',
  seed: 'M12 21v-7m0 0c0-4 3-7 7-7 0 4-3 7-7 7Zm0 0C12 9 9 6 5 6c0 4 3 8 7 8Z',
  key: 'M14.5 9.5a4 4 0 1 1-1.2-2.8M14.5 9.5 21 3m-3 3 2 2m-4 0 2 2M11 13l-7 7v-3h3v-3h3',
  sync: 'M20 11a8 8 0 0 0-14.3-4.9L4 8m0-4v4h4M4 13a8 8 0 0 0 14.3 4.9L20 16m0 4v-4h-4',
  cloud: 'M7 18a4.5 4.5 0 0 1-.5-9A6 6 0 0 1 18 8.5 4.75 4.75 0 0 1 17.5 18H7Zm5-7v5m-2.5-2.5L12 11l2.5 2.5',
  photo: 'M4 5h16v14H4zM4 15l4.5-4.5L13 15m-2-2 2.5-2.5L20 17M15.5 8.5h.01',
  book: 'M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5v-15ZM4 20.5A2.5 2.5 0 0 0 6.5 23H20v-5',
  chat: 'M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-4.6A8 8 0 1 1 21 12Zm-12.5 0h.01m3.99 0h.01m3.99 0h.01',
  check: 'M5 12.5 10 17.5 19 7',
  arrow: 'M5 12h14m-6-6 6 6-6 6',
  chevron: 'm6 9 6 6 6-6',
  menu: 'M4 7h16M4 12h16M4 17h16',
  close: 'M6 6l12 12M18 6 6 18',
  shield: 'M12 3 4.5 6v5.5c0 4.5 3.2 8.3 7.5 9.5 4.3-1.2 7.5-5 7.5-9.5V6L12 3Zm-3.5 9 2.5 2.5 4.5-5',
  pin: 'M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21Zm0-9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-13v4.5l3 2',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  phone: 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z',
  leaf: 'M5 19c0-8 5-14 15-14 0 10-6 15-14 15m-1-1 8-8',
};

export default function Icon({ name, size = 22, className = '' }) {
  return (
    <svg
      className={`icon ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="square"
      strokeLinejoin="miter"
      aria-hidden="true"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
